import { Table, Descriptions, Comment, Spin, Button, Image, Card, Tag } from "antd"
import { EditOutlined, FilePdfOutlined, PrinterOutlined } from "@ant-design/icons"
import { useNavigate, useParams, useLocation } from "react-router"
import React, { useState, useEffect } from "react"
import { Report } from "notiflix"
import { useIsAuthenticated } from "@azure/msal-react"
import numeral from "numeral"
import moment from "moment"

import Navbar from "../../../atoms/navbar"
import Footer from "../../../atoms/footer"
import ApprovalActions from "../../../atoms/approval-actions"
import ApprovalInfo from "../../../atoms/approval-info"

import HeaderFarms from "../../../utils/header_farms"
import API from "../../../services"
import { requestToken } from "../../../auth/AuthServices"
import { travelAuthorityObjectUrl } from "../../../config/url.storage.config"

import "./styles.css"

const STATUS_TAG_COLORS = {
  Approved: "blue",
  "Waiting Approval": "orange",
  Closed: "green",
  Reject: "red",
  Cancel: "default",
}

const SECTION_HEAD_STYLE = {
  background: "#fce8b6",
  fontWeight: 600,
  fontSize: 13,
}

const DESC_LABEL_STYLE = {
  width: 130,
  fontWeight: 500,
  color: "#595959",
  background: "#fafafa",
  whiteSpace: "nowrap",
}

const DESC_CONTENT_STYLE = {
  wordBreak: "break-word",
}

const removeDuplicatesByProps = (array, props) => {
  if (!array) return []
  return array.filter((item, index, self) => index === self.findIndex(el => props.every(p => el[p] === item[p])))
}

const ViewTA = () => {
  const isAuthenticated = useIsAuthenticated()
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  const isApprovalContext = location.pathname.startsWith("/wf/")
  const backUrl = isApprovalContext ? "/wf/pending" : "/ta/history"

  const [TA, setTA] = useState(null)
  const [outstanding, setOutstanding] = useState(null)
  const [dispatcher, setDispatcher] = useState(null)
  const [dispatcherLoading, setDispatcherLoading] = useState(false)

  const status = TA?.data?.approval_process_id?.data?.status
  const statusTagColor = STATUS_TAG_COLORS[status] ?? "default"
  const approvalKey = TA?.data?.approval_process_id?.data?.approval_key

  console.log({ TA })

  const currentSession = (() => {
    try {
      return JSON.parse(localStorage.getItem("session_farms") || "null")
    } catch {
      return null
    }
  })()
  const requestorEmpId =
    TA?.data?.created_by ||
    TA?.data?.requestor_id?.data?.employee_id ||
    TA?.data?.approval_process_id?.data?.created_by
  const isRequestor = !!requestorEmpId && requestorEmpId === currentSession?.employee_id
  const canEdit = !isApprovalContext && isRequestor && status === "Waiting Approval"

  console.log(requestorEmpId, currentSession?.employee_id, isRequestor, canEdit)

  const getDetailTA = async token => {
    try {
      const res = await API.viewTA(HeaderFarms(token), id)
      setTA(res)
    } catch (err) {
      console.error(err)
      Report.info("Travel Authority", "Sorry, Travel Authority not found", "Okay")
    }
  }

  const getOutstanding = async (token, employeeId) => {
    try {
      const res = await API.getLastOutstanding(HeaderFarms(token), {
        nik: employeeId,
      })
      setOutstanding(res)
    } catch (err) {
      console.error(err)
    }
  }

  const getUserAndOutstanding = async token => {
    try {
      const user = await API.getUserCredential(HeaderFarms(token), {
        access_token: token,
      })
      if (user?.nik) await getOutstanding(token, user.nik)
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = await requestToken()
        if (!accessToken) return
        await getDetailTA(accessToken)
        if (!isApprovalContext) {
          await getUserAndOutstanding(accessToken)
        }
      } catch (error) {
        console.error("❌ Gagal mengambil data:", error)
      }
    }

    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, id])

  useEffect(() => {
    const dispatcherId = TA?.data?.dispatcher
    if (!dispatcherId) return
    setDispatcherLoading(true)
    ;(async () => {
      try {
        const token = await requestToken()
        if (!token) return
        const res = await API.ApprovalGetEmployeeDetail(HeaderFarms(token), dispatcherId)
        setDispatcher(res?.data || null)
      } catch (err) {
        console.error("dispatcher lookup failed:", err)
      } finally {
        setDispatcherLoading(false)
      }
    })()
  }, [TA?.data?.dispatcher])

  const getUserList = () => {
    if (!TA) return []
    return TA.data.t_ta_user_dtl.map(user => {
      const { expense_type, reason_for_travel, fieldbreak_date_end, fieldbreak_date_start } = user
      const level = user.employee_id?.data?.job_position || user.m_ta_non_emp?.level
      const fullname = user.employee_id?.data?.fullname || user.m_ta_non_emp?.fullname
      const status_employee_name = user.employee_id?.data?.job_level || user.m_ta_non_emp?.level
      const code = user.employee_id?.data?.branch_nickname || user.m_ta_non_emp?.cost_code
      const department = user.employee_id?.data?.organization_name
      const departure_date_start = moment.utc(user.departure_date_start || fieldbreak_date_start).format("DD-MMM-YY")
      const departure_date_end = moment.utc(user.departure_date_end || fieldbreak_date_end).format("DD-MMM-YY")

      return {
        department,
        code,
        fullname,
        level,
        status_employee_name,
        expense_type,
        reason_for_travel,
        departure_date_end,
        departure_date_start,
      }
    })
  }

  const formatFlight = flight => ({
    from_date: moment.utc(flight.from_date).format("DD-MMM-YY"),
    from: flight.from,
    to: flight.to,
    time: flight.time,
    airline: flight.airline,
    _id: flight._id,
    id_record: flight.t_ta_user_dtl_id,
    e_ticket: flight.e_ticket,
    flight_id: flight.flight_id,
    ticket_price: flight.ticket_price,
    author: flight.author_ticket && flight.author_ticket.fullname,
    seat_class: flight.seat_class,
  })

  const formatAccommodation = a => ({
    dateIn: moment.utc(a.accomodation_date_in).format("DD-MMM-YY"),
    dateOut: moment.utc(a.accomodation_date_out).format("DD-MMM-YY"),
    accommodation: a.accomodation,
    _id: a._id,
  })

  const formatCostEst = c => ({
    item: c.item,
    total: c.total,
    formated: numeral(c.total).format("0,0"),
    _id: c._id,
  })

  const formatDetUser = u => ({
    birth_date: u.birth_date,
    no_ktp: u.nik || u.identity_id,
    place_of_birth: u.birth_place || u.place_of_birth,
    phone_number: u.mobile_phone || u.phone_number,
  })

  const getFlightList = () =>
    removeDuplicatesByProps(TA && TA.data.t_ta_user_dtl.flatMap(u => u.t_ta_rsv_dst_dtl.map(formatFlight)), ["from_date", "from", "to", "time", "airline", "_id", "id_record", "seat_class", "e_ticket", "flight_id", "ticket_price"])

  const getAccommodationDates = () => removeDuplicatesByProps(TA && TA.data.t_ta_user_dtl.flatMap(u => u.t_ta_rsv_hotel_dtl.map(formatAccommodation)), ["dateIn", "dateOut", "accommodation", "_id"])

  const getAccommodationMessDates = () =>
    removeDuplicatesByProps(
      TA &&
        TA.data.t_ta_user_dtl.flatMap(u =>
          u.t_ta_rsv_mess_dtl.map(a => ({
            traveller: u.employee_id?.data?.fullname || u.m_ta_non_emp?.fullname,
            messName: a.mess_name,
          }))
        ),
      ["traveller", "messName"]
    )

  const getDetUserList = () => removeDuplicatesByProps(TA && TA.data?.t_ta_user_dtl?.flatMap(u => formatDetUser(u?.employee_id?.data || u?.m_ta_non_emp)), ["birth_date", "no_ktp", "place_of_birth", "phone_number"])

  const getCostEstlist = () => removeDuplicatesByProps(TA && TA.data.t_ta_user_dtl.flatMap(u => u.t_ta_cost_est_dtl.map(formatCostEst)), ["item", "total", "formated", "_id"])

  const getObjectiveList = () => {
    if (!TA?.data?.t_ta_user_dtl) return []
    return TA.data.t_ta_user_dtl
      .filter(u => u.objective)
      .map(u => ({
        fullName: u.employee_id?.data?.fullname || u.m_ta_non_emp?.fullname,
        objective: u.objective,
        _id: u._id,
      }))
  }

  const getTaskDesc = () => {
    if (!TA?.data?.t_ta_user_dtl) return []
    return TA.data.t_ta_user_dtl
      .filter(u => u.task_description)
      .map(u => ({
        fullName: u.employee_id?.data?.fullname || u.m_ta_non_emp?.fullname,
        task_description: u.task_description,
        _id: u._id,
      }))
  }

  const columnUserList = [
    { title: "Code", dataIndex: "code", key: "code" },
    { title: "Name", dataIndex: "fullname", key: "fullname" },
    { title: "Jabatan", dataIndex: "level", key: "level" },
    { title: "Department", dataIndex: "department", key: "department" },
    { title: "Status", dataIndex: "status_employee_name", key: "status_employee_name" },
  ]

  const columnTravelSchedule = [
    { title: "Name", dataIndex: "fullname", key: "fullname" },
    { title: "Expense Type", dataIndex: "expense_type", key: "expense_type" },
    { title: "Reason", dataIndex: "reason_for_travel", key: "reason_for_travel" },
    { title: "Start", dataIndex: "departure_date_start", key: "departure_date_start" },
    { title: "End", dataIndex: "departure_date_end", key: "departure_date_end" },
  ]

  const columnDetUserList = [
    { title: "NIK", dataIndex: "no_ktp", key: "no_ktp" },
    {
      title: "Date Birth",
      dataIndex: "birth_date",
      key: "birth_date",
      render: d => d && moment.utc(d).format("DD-MMM-YY"),
    },
    { title: "Place of Birth", dataIndex: "place_of_birth", key: "place_of_birth" },
    { title: "Number Phone", dataIndex: "phone_number", key: "phone_number" },
  ]

  const flightListColumns = [
    { title: "From Date", dataIndex: "from_date", key: "from_date" },
    { title: "From", dataIndex: "from", key: "from" },
    { title: "To", dataIndex: "to", key: "to" },
    { title: "Time", dataIndex: "time", key: "time" },
    { title: "Airline", dataIndex: "airline", key: "airline" },
    { title: "Class", dataIndex: "seat_class", key: "seat_class" },
    {
      title: "Ticket Price",
      dataIndex: "ticket_price",
      key: "ticket_price",
      render: t => numeral(t).format("0,0"),
    },
    { title: "Flight ID", dataIndex: "flight_id", key: "flight_id" },
    { title: "Author", dataIndex: "author", key: "author" },
    {
      title: "E - Ticket",
      dataIndex: "e_ticket",
      key: "e_ticket",
      render: text =>
        text ? (
          <Button type="link" size="small" href={`${travelAuthorityObjectUrl.endpoint}/${text}`} target="_blank" rel="noopener noreferrer">
            <FilePdfOutlined /> View
          </Button>
        ) : null,
    },
  ]

  const AccomodationListColumns = [
    { title: "Hotel Name", dataIndex: "accommodation", key: "accommodation" },
    { title: "Date In", dataIndex: "dateIn", key: "dateIn" },
    { title: "Date Out", dataIndex: "dateOut", key: "dateOut" },
  ]

  const AccomodationMessListColumns = [
    { title: "Mess Name", dataIndex: "messName", key: "messName" },
    { title: "Traveller", dataIndex: "traveller", key: "traveller" },
  ]

  const CostEstColumns = [
    { title: "Desc", dataIndex: "item", key: "item" },
    { title: "Total", dataIndex: "formated", key: "formated" },
  ]

  const userList = getUserList()
  const flightList = getFlightList()
  const messList = getAccommodationMessDates()
  const detUserList = getDetUserList()
  const hotelList = getAccommodationDates()
  const costList = getCostEstlist()
  const objectiveList = getObjectiveList()
  const taskDescList = getTaskDesc()

  return (
    <>
      <Navbar title="View" back={true} subtitle="Travel Authority" navigate={backUrl} />
      <div className="ta-view container-fluid white-back-cr px-3 px-md-4">
        <div className="container-xl mt-3">
          {TA && (
            <div className="d-flex justify-content-end mb-3">
              <Button type="primary" onClick={() => navigate("/ta/print/" + id)} title="Print" icon={<PrinterOutlined />}>
                Print
              </Button>
            </div>
          )}

          {!TA && (
            <div className="fs-6 text-center mt-5" style={{ color: "#B7B7B7" }}>
              <Spin size="large" />
            </div>
          )}

          {TA && (
            <>
              <Card
                size="small"
                title="Travel Authority Information"
                style={{ marginBottom: 12 }}
                headStyle={SECTION_HEAD_STYLE}
              >
                <Descriptions
                  size="small"
                  bordered
                  column={1}
                  labelStyle={DESC_LABEL_STYLE}
                  contentStyle={DESC_CONTENT_STYLE}
                >
                  <Descriptions.Item label="Form ID">{TA.data.id_record}</Descriptions.Item>
                  <Descriptions.Item label="Travel Type">{TA.data.type_travel}</Descriptions.Item>
                  <Descriptions.Item label="Status">
                    <Tag color={statusTagColor} style={{ fontSize: 12, fontWeight: 600 }}>
                      {status}
                    </Tag>
                  </Descriptions.Item>
                  <Descriptions.Item label="Created at">{moment(TA.data.created_at).format("LLL")}</Descriptions.Item>
                  <Descriptions.Item label="Dispatcher">
                    {dispatcherLoading ? (
                      <Spin size="small" />
                    ) : (
                      dispatcher?.fullname || TA.data?.dispatcher || "-"
                    )}
                  </Descriptions.Item>
                  {!isApprovalContext && outstanding && (
                    <Descriptions.Item label="Outstanding">{outstanding.data?.balance}</Descriptions.Item>
                  )}
                </Descriptions>
              </Card>

              <Card size="small" style={{ marginBottom: 12 }} bodyStyle={{ padding: 12 }}>
                <ApprovalInfo documentData={TA.data} usePanel={false} />
              </Card>
            </>
          )}

          {userList.length > 0 && (
            <Card size="small" title="Traveler" className="ta-section-card">
              <Table dataSource={userList} className="custom-table" scroll={{ x: "max-content" }} size="small" pagination={{ hideOnSinglePage: true, showLessItems: true }} columns={columnUserList} />
            </Card>
          )}

          {userList.length > 0 && (
            <Card size="small" title="Travel Schedule" className="ta-section-card">
              <Table dataSource={userList} className="custom-table" scroll={{ x: "max-content" }} size="small" pagination={{ hideOnSinglePage: true, showLessItems: true }} columns={columnTravelSchedule} />
            </Card>
          )}

          {flightList.length > 0 && (
            <Card size="small" title="Reservation & Destination" className="ta-section-card">
              <Table dataSource={flightList} className="custom-table" scroll={{ x: "max-content" }} size="small" pagination={{ hideOnSinglePage: true, showLessItems: true }} columns={flightListColumns} />
            </Card>
          )}

          {messList.length > 0 && (
            <Card size="small" title="Accomodation Mess" className="ta-section-card">
              <Table dataSource={messList} className="custom-table" scroll={{ x: "max-content" }} size="small" pagination={{ hideOnSinglePage: true, showLessItems: true }} columns={AccomodationMessListColumns} />
            </Card>
          )}

          {detUserList.length > 0 && (
            <Card size="small" title="Detail Traveler" className="ta-section-card">
              <Table dataSource={detUserList} className="custom-table" scroll={{ x: "max-content" }} size="small" pagination={{ hideOnSinglePage: true, showLessItems: true }} columns={columnDetUserList} />
            </Card>
          )}

          {hotelList.length > 0 && (
            <Card size="small" title="Accomodation Hotel" className="ta-section-card">
              <Table dataSource={hotelList} className="custom-table" scroll={{ x: "max-content" }} size="small" pagination={{ hideOnSinglePage: true, showLessItems: true }} columns={AccomodationListColumns} />
            </Card>
          )}

          {costList.length > 0 && (
            <Card size="small" title="Travel Cost Estimation" className="ta-section-card">
              <Table
                dataSource={[
                  ...costList,
                  {
                    item: "Total Cost",
                    formated: numeral(costList.reduce((acc, c) => acc + c.total, 0)).format("0,0"),
                  },
                ]}
                className="custom-table custom-table-cost"
                scroll={{ x: "max-content" }}
                size="small"
                pagination={{ hideOnSinglePage: true, showLessItems: true }}
                columns={CostEstColumns}
              />
            </Card>
          )}

          {TA && objectiveList.length > 0 && (
            <Card size="small" title="User Objective" className="ta-section-card ta-section-padded">
              {objectiveList.map(item => (
                <div key={item._id}>
                  <Comment author={item.fullName} content={item.objective} />
                </div>
              ))}
            </Card>
          )}

          {TA && taskDescList.length > 0 && (
            <Card size="small" title="Task Description (Assignment Task)" className="ta-section-card ta-section-padded">
              {taskDescList.map(item => (
                <div key={item._id}>
                  <Comment author={item.fullName} content={item.task_description} />
                </div>
              ))}
            </Card>
          )}

          {TA && objectiveList.length > 0 && (
            <Card size="small" title="Attachments" className="ta-section-card ta-section-padded">
              <div className="row g-3">
                {objectiveList.map(item => (
                  <div className="col-6 col-md-4 col-lg-3" key={item._id}>
                    <div className="ta-attachment-tile">
                      <div className="ta-attachment-name text-truncate" title={item.fullName}>
                        {item.fullName}
                      </div>
                      <Image
                        src={`${travelAuthorityObjectUrl.endpoint}/${item._id}.jpeg`}
                        preview={true}
                        placeholder
                        fallback="data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 150'%3E%3Crect width='200' height='150' fill='%23fafafa'/%3E%3Cpath d='M55 95l25-30 20 22 18-15 27 33H55z' fill='%23d9d9d9'/%3E%3Ccircle cx='75' cy='55' r='8' fill='%23d9d9d9'/%3E%3Ctext x='100' y='130' font-family='sans-serif' font-size='10' fill='%238c8c8c' text-anchor='middle'%3ENo image%3C/text%3E%3C/svg%3E"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </Card>
          )}
        </div>

        <ApprovalActions mainData={TA?.data ? { ...TA.data, employee_id: requestorEmpId } : null} canEditData={false} />
      </div>
      <Footer />
    </>
  )
}

export default ViewTA
